export function loading(targetElement, caption = "Loading") {
    const originalInnerHTML = targetElement.innerHTML;
    targetElement.innerHTML = `
    <span class="spinner-border spinner-border-sm" role="status"
          aria-hidden="true"></span>${caption}
    `;
    return function done() {
        targetElement.innerHTML = originalInnerHTML;
    };
}
//# sourceMappingURL=bs-loading-indicator.js.map